import { RxCopy } from '@react-icons/all-files/rx/RxCopy'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { copyToDisco } from '@disco/state-management/actions/ExplorerActions'
import { getTeamLibrary } from '@disco/state-management/selectors/groups'
import { isAggregatedSearchTrack } from '@disco/utils/tracks'

import type { Group } from 'types/group'
import type { PlaylistId } from 'types/playlist'
import type { Track } from 'types/track'

import { DropdownMenu, Flex } from 'components/ds'
import type { MixpanelContext } from 'components/track-actions/track-dropdown'
import Submenu from 'components/track-actions/submenu/dropdown-submenu'

import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  track: Track
  excludeShortlistId: string | null | undefined
  sourceShortlistId?: string | null | undefined
  sourcePlaylistId?: PlaylistId | null | undefined
  closeMenu: () => void
  group?: Group | null | undefined
  disabled: boolean
  addToCustomGroup: boolean
  channelOwner?: number | null | undefined
  mixpanelContext?: MixpanelContext
}

const CopyTrackToOption = ({
  closeMenu,
  track,
  group,
  channelOwner,
  mixpanelContext,
}: Props): React.ReactNode => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const teamLibrary = useSelector(getTeamLibrary)
  const groupId = group?.id

  const links: React.ReactNode[] = [
    <DropdownMenu.Item
      key="browse"
      onSelect={() => {
        const teamLibraryId = teamLibrary?.id
        if (!teamLibraryId) return
        dispatch(
          copyToDisco(
            track.name,
            track?.stream_url,
            { groupIds: [teamLibraryId] },
            groupId,
            {
              Context: mixpanelContext ?? 'Shared Channels',
              Track_Name: track.name,
              Copy_To_Location: 'Browse',
              Copy: 'Browse',
              Type: 'Track',
              'Channel ID': groupId,
              'Channel Owner': channelOwner,
              MDS: isAggregatedSearchTrack(track),
            },
          ),
        )
        closeMenu()
      }}
    >
      Browse
    </DropdownMenu.Item>,
  ]

  if (groupId) {
    links.push(
      <DropdownMenu.Item
        key="channel"
        onSelect={() => {
          navigate(`/explorer/tracks/${track.id}/${groupId}/copy-to-channel`)
        }}
      >
        Channel
      </DropdownMenu.Item>,
      <DropdownMenu.Item
        key="playlist"
        onSelect={() => {
          navigate(`/explorer/tracks/${track.id}/${groupId}/copy-to-playlist`)
        }}
      >
        Playlist
      </DropdownMenu.Item>,
    )
  }

  return (
    <Submenu
      links={links}
      title={
        <Flex align="center" gap="2">
          <RxCopy />
          Copy to
        </Flex>
      }
    />
  )
}

export default CopyTrackToOption
